<template>
  <NavBar  :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
          <Transition class="">
            <video-background 
              playbackRate=0.2
              :src="src"
             
        
              overlay="linear-gradient(to bottom, #003, transparent)" 
              :class="`thing playercss`"
              :style="`height: 556px; width: 100%;`" v-show="pvisvideo === true">
            </video-background>
          </Transition>
          <div id="panorama" class="thing  gradient" v-show="pvisvideo === false && pictureimage === false">
          </div>
          <div v-show="pictureimage === true">
            <img :src="poster" class="img-fluid">
          </div>
        </div>
        
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext"></h1>
        </div>
      </main>
    </section>


    <section style="margin-top: 150px;">
      <DataleftCardright :aboutgovern="aboutgovern" />
    </section>



    <div class="datapdfmandate">
    <DownloadPdf :tabledata="corpgovernmandate" :opssection1="chartermandate" />
  </div>



  <div class="datapdfguideline">
    <DownloadPdf :tabledata="corpgovernpolicy" :opssection1="policyguideline" />
  </div>



  <section class="settingpadding">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 formatleft">
        <div v-html="compliantsprocess"></div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 formatright">
        <img :src="`${cpimg}`" class="imgformat" />
      </div>
    </div>
  </section>

  <section class="lastsection">
    <span v-html="aboutgeneral.pdesc" class="hrspantext"></span>
  </section>

    <FooterPage />
  <!-- <ModalDisplay /> -->
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import LeadershipCards from '@/components/LeadershipCards.vue';
import DataleftCardright from '@/components/DataleftCardright.vue'
import DownloadPdf from '@/components/DownloadPdf.vue'
require('@/globalDeclare.js');
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
// require('@/setup.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, LeadershipCards, DataleftCardright, DownloadPdf
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  pictureimage: '',

 
  aboutgeneral: [],
  showImage: false,
  publicPath: window.location.origin,

  cmimage1: [],
  cmimage2: '',
  cmimage3: '',
  myPicUrl: '',

  aboutgovern: '',
  chartermandate: '',
  policyguideline: '',
  compliantsprocess: '',
  cpimg: '',
  aboutgeneral: [],
  tableshow: false,
  rightimage: '',

  breadcrumbsinfo: [],

  corpgovernmandate: [],
  corpgovernpolicy: [],

  opssection1: '',

  tabledata: []

  }
},

async mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath

//change the page name and the top panorama or video will take effect.
await axios.get('allpagespv/governance').then(
    response => {
      this.videoimage = response.data
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
 

  //------------corpgovernance info---------------
  await axios.get('getcorpgovernanceinfo/').then(
    response => {
        this.aboutgovern = response.data
        this.chartermandate = response.data.chartermandate
        this.policyguideline = response.data.policyguideline
        this.compliantsprocess = response.data.compliantsprocess
        this.cpimg =  response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------mandate table info---------------
  await axios.get('getcorpgovernmandateinfo/governance').then(
  response => {
        this.corpgovernmandate = response.data
  })
  .catch((error) => {
      console.log(error)
    })


  //------------corpgovernpolicy table info---------------
  await axios.get('getcorpgovernpolicyinfo/governance').then(
    response => {
        this.corpgovernpolicy = response.data
  })
  .catch((error) => {
      console.log(error)
    })


  //general page information
  await axios.get('aboutpagegeneral/governance').then(
    response => {
        this.aboutgeneral = response.data
  })
  .catch((error) => {
      console.log(error)
    })



//------------mandate table info---------------
await axios.get('getuploadededfile/governance').then(
    response => {
        this.tabledata = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Operations products page Cards ---------------
await axios.get('getopspageexploration/').then(
    response => { 
    this.opssection1 = response.data[0].opssection1
    console.log(this.opssection1)
  })
  .catch((error) => {
      console.log(error)
    }) 

//------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/governance').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })  
      
}
}


</script>

<style lang="scss" scoped>
@import "@/assets/scss/vendors/bootstrap-vue/_custom.scss";


.topdiv {
  width: 100%;
}
.middlediv {
  width: 100%;
}

.txtright {
  text-align: right;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.hrspantext {
  padding-top: 10px;
}
.imageswidth {
  max-width: 100%;
}

.TextleftDivcss {
  width: 100%;
}
.TextleftDivcss1 {
  color: grey;
  height: auto;
}
.txtoutmdesc {
  margin: 0 auto;
  margin-top: 30px;
  font-size: 26px;
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-weight: bold;
}
.videosection {
  width: 100%;
}
.txtdata {
  position:absolute;
  margin-top: -50px;
  text-align: left;
  margin-left: 0px;
 }

 //formatting
.dataleftrightcss {
  width: 80%;
  margin: 0 auto;
}

.datapdfmandate {
  margin-top: 30px;
}
.datapdfguideline {
  margin-top: 30px;
}


.imgformat{
  width: 100%;
}


/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
 .dataleftsection {
  margin-top: -50px;
 }

 .txtdata {
  width: 400px;
  margin-top: -100px;
  margin-bottom: -200px;
 }


  
  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 30px;

  }
  
  .lastsection {
    margin-top: 30px;
  }

  .settingpadding {
    padding: 30px;
    margin-top: 60px;
  }
  
}

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

   .txtdata {
    width: 400px;
    margin-top: -380px;
    margin-bottom: -200px;
   }

    .datapdfmandate {
      margin-top: 40px;
      padding: 40px;
    }
    .datapdfguideline {
      margin-top: 40px;
  
    }
  
    .lastsection {
      margin-top: 30px;
    }

  .settingpadding {
    padding: 60px;
    margin-top: 60px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  
  .txtdata {
  width: 400px;
  margin-top: -280px;
  margin-bottom: -200px;
  }
  
  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 100px;

  }

 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
    .txtdata {
    width: 500px;
    margin-top: -200px;
    margin-bottom: -200px;
   }

    .datapdfmandate {
      margin-top: 30px;
    }
    .datapdfguideline {
      margin-top: 30px;
  
    }
 

 }

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only  screen and (min-width: 1200px){
  .txtdata {
    width: 500px;
    margin-top: -100px;

   }
  .datapdfmandate {
    margin-top: 30px;
  }
  .datapdfguideline {
    margin-top: 30px;

  }
  .datapdfcompliance {
    margin-top: 30px;
  }
 } 

 @media only  screen and (min-width: 1400px) {


   .txtdata {
    width: 900px;
    margin-top: -200px;
    padding-left: 100px;
    background-color: #003;
    opacity: 0.48;
    color: white;
    border-bottom-right-radius: 65px;
    border-top-right-radius: 65px;
   }

    .datapdfmandate {
      margin-top: 30px;
      background-color: aliceblue;
      padding-top: 40px;
      padding-bottom: 40px;
    }
    .datapdfguideline {
      margin-top: 30px;
  
    }
    .datapdfcompliance {
      background-color: antiquewhite;
      padding-bottom: 40px;
    }

    .settingpadding{
      padding-left: 200px;
      padding-right: 200px;
      padding-bottom: 100px;
      padding-top: 100px;
    }
 }
</style>

